<template>
  <v-container fluid class="px-lg-5">
    <app-header :title="title" :breadcrumbs="breadcrumbs" />
    <v-card class="fill-height" flat outlined v-if="isLoaded">
      <app-tree v-for="(tree, index) in organizationChart" :ref="`scaleTree`" :key="index"
        class="fill-height" :dataset="tree" link-style="straight">
        <template v-slot:node="{ node }">
          <tree-node :data="node" @click="drawer = true"/>
        </template>
        <template v-slot:footer>
          <v-footer color="rgba(0, 0, 0, 0.1)" absolute class="font-weight-medium" padless>
            <v-col class="text-center" cols="12">
              <v-btn v-for="(btn, btnindex) in scalingButtons" :key="btnindex" class="mx-2" fab x-small
                @click="handleScaleChange(btn.action, index)">
                <v-icon dark v-if="btn.icon">{{ btn.icon }}</v-icon>
                <span v-if="btn.text">{{ btn.text }}</span>
              </v-btn>
            </v-col>
          </v-footer>
        </template>
      </app-tree>
    </v-card>
  </v-container>
</template>

<script>
import TreeNode from 'components/users/TreeNode';
import {mapActions, mapGetters} from 'vuex';

export default {
  components: {
    TreeNode
  },
  data() {
    return {
      title: {
        text: this.$t('layout.mainMenu.organizationChart'),
        icon: 'mdi-sitemap'
      },
      breadcrumbs: [{
        text: this.$t('layout.mainMenu.home'),
        to: {name: 'Home'}
      },
      {
        text: this.$t('layout.mainMenu.organizationChart'),
        to: {name: 'OrganizationChart'},
        exact: true
      }],
      isLoaded: false,
      drawer: false,
      scalingButtons: [
        {
          action: 'zoomIn',
          icon: 'mdi-plus'
        },
        {
          action: 'zoomOut',
          icon: 'mdi-minus'
        },
        {
          action: 'restore',
          text: '1:1'
        }
      ]
    };
  },
  computed: mapGetters(['organizationChart']),
  methods: {
    ...mapActions(['getOrganizationChart']),
    handleScaleChange(command, treeIndex) {
      const scaledTree = this.$refs.scaleTree[treeIndex];
      switch (command) {
      case 'zoomIn':
        scaledTree.zoomIn();
        break;
      case 'zoomOut':
        scaledTree.zoomOut();
        break;
      case 'restore':
        scaledTree.restoreScale();
        break;
      }
    },
    fitTreeToContainer() {
      this.$nextTick(() => {
        this.$refs.scaleTree.forEach((tree) => {
          const container = tree.$refs.container;
          const domContainer = tree.$refs.domContainer;

          if (!container || !domContainer) return;
          const containerHeight = container.offsetHeight;
          const containerWidth = container.offsetWidth;

          const treeHeight = domContainer.scrollHeight;
          const treeWidth = domContainer.scrollWidth;
          if (!treeHeight || !treeWidth) return;

          const heightScale = containerHeight / treeHeight;
          const widthScale = containerWidth / treeWidth;

          const scale = Math.min(heightScale, widthScale) * tree.config.scale;
          if (scale >= 1) return;

          const scaledHeight = treeHeight * scale;
          const offsetX = tree.initTransformX;
          const offsetY = (containerHeight - scaledHeight) / 2;

          const transform = `translate(${offsetX}px, ${offsetY}px) scale(${scale})`;

          domContainer.style.transform = transform;
          if (tree.$refs.svg) {
            tree.$refs.svg.style.transform = transform;
          }
        });
      });
    }
  },
  created() {
    this.getOrganizationChart().then(() => {
      this.isLoaded = true;
      this.fitTreeToContainer();
    });
  }
};
</script>
<style scoped>
  .tree-container {
    border: 1px solid #e0e0e0;
  }
</style>
